var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusicDistribution = function SvgMusicDistribution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_197)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_197",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "var(--on-surface)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_197)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3_197)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#16AD40",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6384 14.6563L39.3094 12.157L39.3083 12.1563C37.5694 11.1528 34.8687 11.4617 30.0449 12.0133L22.2949 12.8995C16.8148 13.5261 14.0748 13.8394 12.3723 15.7969C10.6699 17.7544 10.6699 20.5917 10.6699 26.2662V30.2786C10.6699 35.9531 10.6699 38.7904 12.3723 40.3585C12.5762 40.5463 12.7949 40.7071 13.0315 40.8437L17.3605 43.343C17.1244 43.2066 16.906 43.046 16.7024 42.8585C15 41.2904 15 38.4531 15 32.7786V28.7662C15 23.0917 15 20.2544 16.7024 18.2969C18.4049 16.3394 21.1449 16.0261 26.625 15.3995L34.375 14.5133C38.5372 14.0373 41.1188 13.7421 42.8656 14.3147L44.2976 15.1415C44.0937 14.9537 43.8749 14.7929 43.6384 14.6563Z",
    fill: "#16AD40"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.6384 14.6563L39.3094 12.157L39.3083 12.1563C37.5694 11.1528 34.8687 11.4617 30.0449 12.0133L22.2949 12.8995C16.8148 13.5261 14.0748 13.8394 12.3723 15.7969C10.6699 17.7544 10.6699 20.5917 10.6699 26.2662V30.2786C10.6699 35.9531 10.6699 38.7904 12.3723 40.3585C12.5762 40.5463 12.7949 40.7071 13.0315 40.8437L17.3605 43.343C17.1244 43.2066 16.906 43.046 16.7024 42.8585C15 41.2904 15 38.4531 15 32.7786V28.7662C15 23.0917 15 20.2544 16.7024 18.2969C18.4049 16.3394 21.1449 16.0261 26.625 15.3995L34.375 14.5133C38.5372 14.0373 41.1188 13.7421 42.8656 14.3147L44.2976 15.1415C44.0937 14.9537 43.8749 14.7929 43.6384 14.6563Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6384 14.6563L39.3094 12.157L39.3083 12.1563C37.5694 11.1528 34.8687 11.4617 30.0449 12.0133L22.2949 12.8995C16.8148 13.5261 14.0748 13.8394 12.3723 15.7969C10.6699 17.7544 10.6699 20.5917 10.6699 26.2662V30.2786C10.6699 35.9531 10.6699 38.7904 12.3723 40.3585C12.5762 40.5463 12.7949 40.7071 13.0315 40.8437L17.3605 43.343C17.1244 43.2066 16.906 43.046 16.7024 42.8585C15 41.2904 15 38.4531 15 32.7786V28.7662C15 23.0917 15 20.2544 16.7024 18.2969C18.4049 16.3394 21.1449 16.0261 26.625 15.3995L34.375 14.5133C38.5372 14.0373 41.1188 13.7421 42.8656 14.3147L44.2976 15.1415C44.0937 14.9537 43.8749 14.7929 43.6384 14.6563Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.7662C15 23.0917 15 20.2544 16.7024 18.2969C18.4049 16.3394 21.1449 16.0261 26.625 15.3995L34.375 14.5133C39.8551 13.8866 42.5951 13.5733 44.2976 15.1415C46 16.7096 46 19.5469 46 25.2214V29.2338C46 34.9083 46 37.7455 44.2976 39.7031C42.5951 41.6606 39.8551 41.9739 34.375 42.6005L26.625 43.4867C21.1449 44.1134 18.4049 44.4267 16.7024 42.8585C15 41.2904 15 38.4531 15 32.7786V28.7662Z",
    fill: "#16AD40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1649 27.5846C41.1649 31.7268 37.8275 35.4554 33.7107 35.9129V37.4129C38.6509 36.864 42.6557 32.3895 42.6557 27.419C42.6557 22.4484 38.6509 18.864 33.7107 19.4129V20.9129C37.8275 20.4554 41.1649 23.4425 41.1649 27.5846Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.674 27.7503C39.674 31.064 37.0042 34.0469 33.7107 34.4129V32.9129C36.1808 32.6384 38.1832 30.4012 38.1832 27.9159C38.1832 25.4306 36.1808 23.6384 33.7107 23.9129V22.4129C37.0042 22.0469 39.674 24.4366 39.674 27.7503Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6924 28.0816C36.6924 29.7384 35.3575 31.2299 33.7107 31.4129V29.9129C34.5341 29.8214 35.2016 29.0756 35.2016 28.2472C35.2016 27.4188 34.5341 26.8214 33.7107 26.9129V25.4129C35.3575 25.2299 36.6924 26.4247 36.6924 28.0816Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7291 32.8662C30.7291 33.8676 29.862 34.9256 28.5831 35.3755C27.1066 35.8971 25.6469 35.4123 25.3222 34.2922C24.9974 33.1721 25.9315 31.8461 27.4079 31.3246C27.9938 31.1165 28.573 31.0734 29.0853 31.1619V25.9827L23.2096 28.4624V34.7268C23.2096 34.7299 23.2113 34.7328 23.213 34.7357C23.2147 34.7386 23.2163 34.7415 23.2163 34.7446C23.2163 36.2144 22.329 37.2903 21.1339 37.7119C19.6575 38.2334 18.1978 37.7486 17.8731 36.6285C17.5483 35.5084 18.4824 34.1825 19.9588 33.6609C20.4643 33.4804 20.9632 33.4308 21.4218 33.4726V26.3308C21.4218 26.0611 21.5993 25.7995 21.8705 25.6699L29.7615 21.8984C30.2235 21.6762 30.7291 21.939 30.7291 22.401V32.8662Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "url(#paint0_linear_3_197)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3_197",
    x: -4,
    y: -2,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_3_197"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_197"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.101961 0 0 0 0 0.666667 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3_197",
    result: "effect2_dropShadow_3_197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_3_197",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_197",
    x1: 0,
    y1: 0,
    x2: 56,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
export default SvgMusicDistribution;